import { render } from "./NotFoundBox.vue?vue&type=template&id=6e80cf52&scoped=true"
import script from "./NotFoundBox.vue?vue&type=script&lang=js"
export * from "./NotFoundBox.vue?vue&type=script&lang=js"

import "./NotFoundBox.vue?vue&type=style&index=0&id=6e80cf52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e80cf52"]])

export default __exports__